/** Metadata is already authorized by the server; original ledger IDs remain payment targets. */
export function cashCounterpartyLabel(party) {
    const common = party.canonicalName || party.name;
    return common === party.name ? common : `${common} · ${party.name}`;
}
export function cashCounterpartyMatches(party, search) {
    return [party.name, party.canonicalName, ...(party.aliases || [])].filter(Boolean).join(' ').toLocaleLowerCase().includes(search.trim().toLocaleLowerCase());
}
